var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 3.33317V1.6665M7.99984 3.33317C9.29181 3.33317 10.4305 3.74195 11.4017 4.33317M7.99984 3.33317C6.70787 3.33317 5.56919 3.74195 4.59795 4.33317M11.4017 4.33317C12.6276 5.07938 13.5867 6.11623 14.2506 6.98861C15.0131 7.99048 15.0128 9.34312 14.2502 10.345C13.0602 11.9084 10.9221 13.9998 7.99984 13.9998C5.07754 13.9998 2.93951 11.9084 1.74945 10.345C0.986905 9.34312 0.986536 7.99048 1.74903 6.98861C2.41297 6.11623 3.37209 5.07938 4.59795 4.33317M11.4017 4.33317L12.3332 2.99984M4.59795 4.33317L3.6665 2.99984M9.99984 8.6665C9.99984 9.77107 9.10441 10.6665 7.99984 10.6665C6.89527 10.6665 5.99984 9.77107 5.99984 8.6665C5.99984 7.56193 6.89527 6.6665 7.99984 6.6665C9.10441 6.6665 9.99984 7.56193 9.99984 8.6665Z",
    stroke: "#BAE629",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.5b349ced88f344b1493875d023d7df36.svg";
export { ForwardRef as ReactComponent };